export default "__VITE_ASSET__901e096d__"